import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CONSENT_CHANGED_EVENT, hasAnalyticsConsent, trackSpaPageView } from '../utils/cookieConsent';

/**
 * Sends GA4 page_view on React Router navigations when analytics consent is granted.
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!hasAnalyticsConsent()) return undefined;
    trackSpaPageView(`${location.pathname}${location.search}`);
    return undefined;
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onConsent = (event) => {
      if (event?.detail?.analytics) {
        trackSpaPageView(`${window.location.pathname}${window.location.search}`);
      }
    };
    window.addEventListener(CONSENT_CHANGED_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onConsent);
  }, []);

  return null;
}
